export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-calender-button-1.0.0',
    name: 'JDSDatepickerCalendarButton'
  },
  hierarchy: {
    container: [
      {
        'button-container': ['jds-text']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{d_0}',
      'justify-content': '{d_1}',
      'align-items': '{d_2}',
      width: '{d_3}',
      height: '{d_4}',
      show: true
    },
    'button-container': {
      hidden: false,
      'flex-direction': '{d_5}',
      'justify-content': '{d_6}',
      'align-items': '{d_7}',
      width: '{d_8}',
      height: '{d_9}',
      'border-radius': '{d_10}',
      'border-width': 0,
      'border-color': '{d_11}',
      'background-color': '{d_12}',
      behavior: {
        hover: {
          'background-color': '{d_13}'
        },
        active: {
          'background-color': '{d_14}'
        },
        focus: {
          'background-color': '{d_15}',
          'border-width': '{d_16}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_187}',
      color: '{text_13}',
      'font-size': '{text_186}',
      'line-height': '{text_188}',
      'letter-spacing': '{text_189}',
      'font-weight': '{text_190}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    state: {
      selected: {
        'button-container': {
          'background-color': '{d_17}'
        },
        'jds-text': {
          color: '{text_18}',
          behavior: {
            hover: {
              color: '{text_13}'
            },
            focus: {
              color: '{text_13}'
            }
          }
        }
      },
      current: {
        'button-container': {
          'background-color': '{d_18}'
        }
      },
      empty: {
        'button-container': {
          hidden: true
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{d_19}'
        },
        'button-container': {
          disabled: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      state: {
        values: ['default', 'selected', 'current', 'empty']
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      'jds-text': {
        value: {
          type: 'string',
          name: 'value'
        }
      }
    },
    events: {
      'button-container': {
        onClick: 'onClick'
      }
    },
    a11y: {
      'button-container': {
        properties: {
          role: {
            value: 'radio'
          },
          'aria-label': {
            name: 'ariaLabel',
            function: true
          },
          'aria-current': '_ariaCurrent',
          'aria-checked': '_ariaChecked'
        }
      }
    }
  }
};
